// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yp0_","col":"styles_col__2v9w-"};